<template>
  <div class="row">
    <div class="col-12 text-center">
      <h1>{{ items[status].title }}</h1>
      <HMCustomContent
        class="mt-3"
        v-if="items[status].description"
        :json="items[status].description"
      />
      <HMButton @click="$emit('close')" color="brand" class="mt-4">
        {{ items[status].button }}
      </HMButton>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  props: {
    solvedQuiz: {
      required: true,
      type: Object as () => StudentSolvedQuizResponse,
    },
  },
  computed: {
    items() {
      const solvedQuiz = this.solvedQuiz as StudentSolvedQuizResponse;

      return {
        passed: {
          img: '/assets/images/thank-you.svg',
          title:
            solvedQuiz.quiz.passed_title ||
            this.$t('QUIZZES.LABEL.PASSED_QUIZ_MESSAGE'),
          description: solvedQuiz.quiz.passed_description,
          button: this.$t('GENERAL.BUTTON.CONTINUE'),
        },
        failed: {
          img: '/assets/images/sad.svg',
          title:
            solvedQuiz.quiz.failed_title ||
            this.$t('QUIZZES.LABEL.FAILED_QUIZ_MESSAGE'),
          description: solvedQuiz.quiz.failed_description,
          button: this.$t('GENERAL.BUTTON.CLOSE'),
        },
        neutral: {
          img: '/assets/images/thank-you.svg',
          title:
            solvedQuiz.quiz.neutral_title ||
            this.$t('QUIZZES.LABEL.NEUTRAL_QUIZ_MESSAGE'),
          description: solvedQuiz.quiz.neutral_description,
          button: this.$t('GENERAL.BUTTON.CONTINUE'),
        },
      };
    },
    status() {
      const solvedQuiz = this.solvedQuiz as StudentSolvedQuizResponse;
      const is_gradable = solvedQuiz.quiz.is_gradable;
      const { is_passed, is_graded } = solvedQuiz;

      if (is_gradable) {
        if (is_graded) {
          return is_passed ? 'passed' : 'failed';
        }
      }
      return 'neutral';
    },
  },
};
</script>
